<template>
	<header-menu-admin />
	
	<!-- Main Sections -->
	<main class="main-wrapper bg-lightest-gray">

		<!-- About Section Start -->
		<section class="about-section py-40">
			<div class="container-fluid">
				<div class="top-bar mb-16 d-block text-end">
					<router-link :to="{path: '/admin/products/add'}" class="btn btn-primary">
						Добавить товар
					</router-link>
				</div>
				<div class="about-wrapper bg-white">
					<div class="about-block">
						<div class="table-responsive">
							<table class="table table-hover mb-0">
								<thead>
									<tr>
										<th width="150" style="min-width: 150px; vertical-align: middle; text-align: center;">Постер</th>
										<th style="vertical-align: middle;">Название товара</th>
										<th style="vertical-align: middle;">Категория</th>
										<th width="100" style="min-width: 100px; vertical-align: middle; text-align: center;">Цена</th>
										<th width="150" style="min-width: 150px; vertical-align: middle; text-align: right;">Операции</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="product in products" :key="product.id">
										<td style="vertical-align: middle; text-align: center;">
											<div class="icon-box">
												<img :src="'/'+product.poster" style="width: 100%;" alt="">
											</div>
										</td>
										<td style="vertical-align: middle;">{{product.name}}</td>
										<td style="vertical-align: middle;">{{product.category_name}}</td>
										<td style="vertical-align: middle;">
											<small class="text-muted"><s>{{number_format(product.oldPrice)}} тг</s></small>
											<div>{{number_format(product.price)}} тг</div>
										</td>
										<td style="vertical-align: middle; text-align: right">
											<router-link :to="{path: '/admin/products/'+product.id}" class="btn btn-sm btn-primary me-2">
												<svg width="24" height="24" fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z" /></svg>
											</router-link>
											<button type="button" class="btn btn-sm btn-danger" @click="onDelete(product.id)">
												<svg width="24" height="24" fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" /></svg>
											</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="text-center mt-2">
						<div class="mb-1">Всего товаров: {{products_count}}</div>
						<nav aria-label="Page navigation">
							<ul class="pagination justify-content-center mb-0">
								<li class="page-item" :class="{'disabled': page == 1}">
									<a class="page-link p-1" href="javascript://" @click="gotoPage(page - 1)" aria-label="Previous">
										<svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" /></svg>
									</a>
								</li>
								<li class="page-item" :class="{'active': page == 1}">
									<a class="page-link" href="javascript://" @click="gotoPage(1)">1</a>
								</li>
								<li class="page-item disabled" v-if="page - paginationAlpha > 2">
									<span class="page-link">...</span>
								</li>
								<li class="page-item" :class="{'active': page == i}" v-for="i in range(paginationA1, paginationA2)" :key="i" v-show="paginationA2 >= paginationA1">
									<a class="page-link" href="javascript://" @click="gotoPage(i)">{{i}}</a>
								</li>
								<li class="page-item disabled" v-if="page + paginationAlpha < getPagesCount() - 1">
									<span class="page-link">...</span>
								</li>
								<li class="page-item" :class="{'active': page == getPagesCount()}" v-if="getPagesCount() > 1">
									<a class="page-link" href="javascript://" @click="gotoPage(getPagesCount())">{{getPagesCount()}}</a>
								</li>
								<li class="page-item" :class="{'disabled': page == getPagesCount() || getPagesCount() == 0}">
									<a class="page-link p-1" href="javascript://" @click="gotoPage(page + 1)" aria-label="Next">
										<svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg>
									</a>
								</li>
							</ul>
						</nav>
					</div>
				</div>
			</div>
		</section>
		<!-- About Section End -->
	</main>
	<!-- Main Sections -->
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import HeaderMenuAdmin from '@/components/HeaderMenuAdmin';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech Admin'});
	},
	data: () => ({
		products: [],
		products_count: 0,
		
		page: 1,
		limit: 8,
		loading: true,
		error: '',
		
		paginationAlpha: 3,
	}),
	computed: {
		paginationA1(){
			return Math.max(this.page - this.paginationAlpha, 2);
		},
		paginationA2(){
			return Math.min(this.page + this.paginationAlpha, this.getPagesCount() - 1);
		},
	},
	methods: {
		formatDate: lib.formatDate,
		range: lib.range,
		number_format(value){
			return lib.number_format(value, 0, '.', ' ');
		},
		
		async loadData(){
			this.loading = true;
			this.error = '';
			const params = {
				start: (this.page - 1) * this.limit,
				limit: this.limit,
			};
			const ret = await this.appModel.doGetProducts(params);
			if(ret.success){
				this.products = ret.list;
				this.products_count = ret.count;
			} else {
				this.error = ret.message;
			}
			this.loading = false;
		},
		
		gotoPage(page){
			if(page >= 1 && page <= this.getPagesCount() && page != this.page){
				this.page = page;
				this.loadData();
				window.scrollTo(0, 0);
			}
		},
		// получение количества страниц
		getPagesCount(){
			return Math.ceil(this.products_count / this.limit);
		},
		
		async onDelete(id){
			if(confirm('Вы уверены, что хотите удалить данный товар?')){
				const ret = await this.appModel.doDeleteProduct(id);
				if(ret.success){
					this.loadData();
				} else {
					alert(ret.error);
				}
			}
		},
	},
	async mounted(){
		window.scrollTo(0, 0);
		
		await this.loadData();
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		HeaderMenuAdmin,
	},
};
</script>